import { Component } from '@angular/core';
import { RechercheGdfService } from 'src/app/shared/services/recherche-gdf.service';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { SelectionModel } from '@angular/cdk/collections';
import { GdfResult } from 'src/app/shared/models/recherche-gdf';
import { WorkspaceState } from '@igo2/integration';
import { BehaviorSubject } from 'rxjs';
import { ToolComponent } from '@igo2/common/tool';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { MatRadioModule } from '@angular/material/radio';
import { DossierTerrainGdfComponent } from './dossier-terrain-gdf/dossier-terrain-gdf.component';
import { DroitGdfComponent } from './droit-gdf/droit-gdf.component';
import { TransactionGdfComponent } from './transaction-gdf/transaction-gdf.component';
import { IntervenantGdfComponent } from './intervenant-gdf/intervenant-gdf.component';
import { AvisPriseProssessionGdfComponent } from './avis-prise-prossession-gdf/avis-prise-prossession-gdf.component';
import { MatDividerModule } from '@angular/material/divider';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { StyleModalLayerButtonComponent } from '@igo2/geo';
import { MatIconModule } from '@angular/material/icon';

@ToolComponent({
  name: 'sigt-recherche-gdf',
  title: 'igo.integration.tools.sigtRechercheGdf',
  icon: {
    name: 'recherche-gdf',
    svg: `
      <svg id="recherche-gdf" viewBox="0 0 24 24">
        <path d="M 10.443 1.087 C 12.423 1.087 14.028 2.692 14.028 4.671 C 14.028 5.559 13.703 6.376 13.168 7.003 L 13.318 7.152 L 13.753 7.152 L 16.509 9.909 L 15.682 10.737 L 12.925 7.98 L 12.925 7.545 L 12.776 7.395 C 12.148 7.93 11.332 8.255 10.443 8.255 C 8.465 8.255 6.86 6.651 6.86 4.671 C 6.86 2.692 8.465 1.087 10.443 1.087 M 10.443 2.19 C 9.065 2.19 7.962 3.293 7.962 4.671 C 7.962 6.049 9.065 7.152 10.443 7.152 C 11.822 7.152 12.925 6.049 12.925 4.671 C 12.925 3.293 11.822 2.19 10.443 2.19 Z" style="transform-box: fill-box; transform-origin: 50% 50%;"/>
        <text style="font-family: Roboto, sans-serif; font-size: 9.8px; white-space: pre;" x="2.735" y="22.495"><title>GDF</title>GDF</text>
      </svg>`
  }
})
@Component({
    selector: 'app-sigt-recherche-gdf',
    templateUrl: './sigt-recherche-gdf.component.html',
    styleUrls: ['./sigt-recherche-gdf.component.scss'],
    imports: [
        TranslateModule,
        CommonModule,
        MatRadioModule,
        MatDividerModule,
        MatTableModule,
        MatCheckboxModule,
        MatButtonModule,
        MatTooltipModule,
        MatIconModule,
        DossierTerrainGdfComponent,
        DroitGdfComponent,
        TransactionGdfComponent,
        IntervenantGdfComponent,
        AvisPriseProssessionGdfComponent,
        StyleModalLayerButtonComponent
    ]
})
export class SigtRechercheGdfComponent {
  gdfSearchChoice: string = '';
  gdfLayersInfo: BehaviorSubject<any> = new BehaviorSubject(null);

  colonnesTableResultats = ['select', 'nomCouche', 'style', 'grille', 'visibility'];
  gdfResults: GdfResult[] = [];
  resultatsTableDataSource = new MatTableDataSource<GdfResult>(this.gdfResults);
  selection = new SelectionModel<GdfResult>(true, []);

  constructor(
    private rechercheGdfService: RechercheGdfService,
    private workspaceState: WorkspaceState) {

    rechercheGdfService.layers$.subscribe(results => {
      this.gdfResults = [];
      this.selection.clear();
      results.forEach(layer => {
        this.gdfResults.push(
          {
            typeRecherche: this.gdfSearchChoice,
            idCouche: layer.options.title,
            nomCouche: layer.options.title,
            layer: layer
          });
      });
      this.resultatsTableDataSource.data = this.gdfResults;
    });
  }

  selectGdfSearchChoice(event) {
    this.gdfSearchChoice = event.value as string;
  }

  deleteResults() {
    this.selection.selected.forEach(row => {
      this.rechercheGdfService.removeLayer(row.layer);
    });
    this.selection.clear();
  }

  toggleAllRows() {
    this.isAllSelected() ?
      this.selection.clear() :
      this.resultatsTableDataSource.data.forEach(row => this.selection.select(row));
  }

  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.resultatsTableDataSource.data.length;
    return numSelected === numRows;
  }

  checkboxLabel(row?: GdfResult): string {
    if (!row) {
      return `${this.isAllSelected() ? 'Déselectionner' : 'Sélectionner'} tout`;
    }
    return `${this.selection.isSelected(row) ? 'Déselectionner' : 'Sélectionner'} résultat ${row.nomCouche}`;
  }

  ouvrirGrille(row: GdfResult) {
    if (this.workspaceState.workspace$.value &&
      (this.workspaceState.workspace$.value as any).layer.id === row.layer.id &&
      this.workspaceState.expanded()) {
      this.workspaceState.expanded.set(false);
    } else {
      this.workspaceState.expanded.set(true);
      this.workspaceState.setActiveWorkspaceById(row.layer.id);
    }
  }

  showHideLayer(row: GdfResult) {
    row.layer.visible = !row.layer.visible;
  }
}
